export type FieldShowWhen =
  | { field: string; equals: string }
  | { field: string; oneOf: string[] }
  | { field: string; notEquals: string };

export function isFieldVisible(
  field: { showWhen?: FieldShowWhen | FieldShowWhen[] },
  formData: Record<string, string>,
): boolean {
  if (!field.showWhen) return true;
  const rules = Array.isArray(field.showWhen) ? field.showWhen : [field.showWhen];
  return rules.every((rule) => {
    const val = formData[rule.field] ?? '';
    if ('equals' in rule) return val === rule.equals;
    if ('oneOf' in rule) return rule.oneOf.includes(val);
    if ('notEquals' in rule) return val !== rule.notEquals;
    return true;
  });
}

export function visibleFields<T extends { showWhen?: FieldShowWhen | FieldShowWhen[] }>(
  fields: T[],
  formData: Record<string, string>,
): T[] {
  return fields.filter((f) => isFieldVisible(f, formData));
}
